import EmojiData from '@web-lite/emoji-mart-data/sets/14/apple.json'
// @ts-ignore
import Picker from '@web-lite/emoji-mart-react'

export function EmojiPickerBase({
  i18n,
  onClickAway,
  onSelect,
}: {
  i18n?: Record<string, any>
  onClickAway: () => unknown
  onSelect: (emoji: string) => unknown
}) {
  return (
    <Picker
      data={EmojiData}
      set="apple"
      i18n={i18n}
      perLine={8}
      emojiSize={24}
      theme="light"
      previewPosition="none"
      navPosition="bottom"
      onEmojiSelect={({ native }: { native: string }) => onSelect(native)}
      onClickOutside={onClickAway}
      getSpritesheetURL={(set: string) => {
        return window.config?.frontend.EMOJI_SPRITE_SHEET?.replace(
          /{EMOJI_SET}/g,
          set,
        )
      }}
    />
  )
}
